import api from './client-api';

const getDomains = () => {
  return api.Get('/domains/')
}

export { getDomains }